import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const MessageThickIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M4 5H20V16H9L4 20V16V5Z"
        strokeWidth={2}
        stroke={color}
      />
    </svg>
  );
};

export default MessageThickIcon;
